export const PLANNER_DISCOVERY_SPOTLIGHT_MESSAGE_ID =
  'planner-discovery-spotlight';
export const PLANNER_DISCOVERY_SPOTLIGHT_TARGET = 'planner-discovery-spotlight';
